import React from 'react'

import ContentType from './ContentType'
import RequestParams from './Params'
import { Button } from '~components/Explorer'

import { request } from './Request.module.scss'

const Request = ({ 
  endpoint, 
  explorer,
  microcopy
}) => (
  <>
    { endpoint.params?.[0] && (
      <div id='request' className={ request }>
        <Button explorer={explorer} endpoint={endpoint} />
        <header>
          <h2>
            <a href='#request' data-display-anchor>
              { microcopy.text('reference.titles.request') }
            </a>
          </h2>
        </header>

        <ContentType value={ 
          endpoint.requestContentType || microcopy.text('reference.content_type.none')
        } />

        <RequestParams
          explorer={explorer}
          endpoint={endpoint}
          microcopy={microcopy} />
      </div>
    )}
  </>
)

export default Request